/* eslint-disable import/prefer-default-export */
export const CHANGE_PLACEHOLDER_POSITION = 'CHANGE_PLACEHOLDER_POSITION';
